import React from 'react';
import { currentVersion } from 'config';

function HiddenBuildDate() {
  if (currentVersion) {
    return <span style={{ display: 'none' }}>{currentVersion}</span>;
  }
}

export default HiddenBuildDate;
